// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3bjn6","card":"Cards_card__eGUfZ","infected":"Cards_infected__-adYp","recoverded":"Cards_recoverded__2U2DG","deaths":"Cards_deaths__Qdjzq"};